import React from 'react'
import {
  DataTable,
  Heading,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Text
} from 'base-ui'

import { PageWrapper } from './PageWrapper'
import Highlighter from './Highlight'
import { Table as TableExample } from '../examples/Table'
import { DataTable as DataTableExample } from '../examples/DataTable'

const rows = [
  {
    key: 1,
    song: 'The Sliding Mr. Bones (Next Stop, Pottersville)',
    artist: 'Malcolm Lockyer',
    year: 1961
  },
  {
    key: 2,
    song: 'Witchy Woman',
    artist: 'The Eagles',
    year: 1972
  },
  {
    key: 3,
    song: 'Shining Star',
    artist: 'Earth, Wind, and Fire',
    year: 1976
  }
]

const columns = [
  {
    title: 'Song',
    key: 'song'
  },
  {
    title: 'Artist',
    key: 'artist'
  },
  {
    title: 'Year',
    key: 'year'
  }
]

const Tables = () => (
  <PageWrapper title='Tables'>
    <Text size='md'>A table displays rows of data.</Text>
    <Heading size='h3'>Data Table</Heading>
    <div className='bg-gray-50 p-4 my-4 rounded-md'>
      <DataTable rows={rows} columns={columns} />
    </div>
    <Heading size='h3'>Usage</Heading>
    <Highlighter code={DataTableExample} language='jsx' className='py-4' />
    <Heading size='h3'>Basic Table</Heading>
    <div className='bg-gray-50 p-4 my-4 rounded-md'>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Song</TableCell>
            <TableCell>Artist</TableCell>
            <TableCell>Year</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow>
            <TableCell>
              The Sliding Mr. Bones (Next Stop, Pottersville)
            </TableCell>
            <TableCell>Malcolm Lockyer</TableCell>
            <TableCell>1961</TableCell>
          </TableRow>
          <TableRow>
            <TableCell>Witchy Woman</TableCell>
            <TableCell>The Eagles</TableCell>
            <TableCell>1972</TableCell>
          </TableRow>
          <TableRow>
            <TableCell>Shining Star</TableCell>
            <TableCell>Earth, Wind, and Fire</TableCell>
            <TableCell>1976</TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </div>
    <Heading size='h3'>Usage</Heading>
    <Highlighter code={TableExample} language='jsx' className='py-4' />
  </PageWrapper>
)

export default Tables
